import React, { FC, ReactElement, useEffect, useState } from "react";
import { InputNumber, Typography, Button, message } from "antd";
import { PerfumeResponse } from "../../../types/types";
import RemoveButton from "./RemoveButton";

type PropsType = {
  perfume: PerfumeResponse;
  perfumeInCart: number;
  onChangePerfumeItemCount: (perfumeId: number, inputValue: number) => void;
  deleteFromCart: (perfumeId: number) => void;
};

const CartItem: FC<PropsType> = ({
  perfume,
  perfumeInCart,
  onChangePerfumeItemCount,
  deleteFromCart,
}): ReactElement => {

  const minQty = perfume.minQuantity || 1;

  const [perfumeCount, setPerfumeCount] = useState(minQty);

  useEffect(() => {
    if (perfumeInCart < minQty) {
      setPerfumeCount(minQty);
      onChangePerfumeItemCount(perfume.id, minQty);
    } else {
      setPerfumeCount(perfumeInCart);
    }
  }, [perfumeInCart]);

  const handlePerfumesCount = (value: number | null): void => {
    let qty = value ?? minQty;

    if (qty < minQty) {
      message.warning(`Minimum quantity is ${minQty}`);
      qty = minQty;
    }

    setPerfumeCount(qty);
    onChangePerfumeItemCount(perfume.id, qty);
  };

  return (
    <div className="cart-item">
      <div className="cart-item-image">
        <img src={perfume.filename} alt={perfume.perfumeTitle} />
      </div>

      <div className="cart-item-details">
        <div className="ci-header">
          <Typography.Title level={5} className="ci-title">
            {perfume.perfumeTitle}
          </Typography.Title>
          <div className="ci-brand">{perfume.brand}</div>
        </div>

        <div className="ci-actions">
          <div className="ci-qty">
            <span>Qty: </span>
            <InputNumber
              min={minQty}
              max={99}
              value={perfumeCount}
              onChange={handlePerfumesCount}
              size="small"
            />
          </div>

          <Button
            type="text"
            className="remove-btn"
            onClick={() => deleteFromCart(perfume.id)}
          >
            Remove
          </Button>
        </div>

        <div className="ci-price">₹{perfume.price * perfumeCount}</div>

        <div style={{ fontSize: 12, color: "#006400" }}>
          Min Quantity: <b>{minQty}</b>
        </div>
      </div>
    </div>
  );
};

export default CartItem;
